import ItemDataService from "../../services/item.service";
import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../fbconfig";
import { useHistory } from "react-router-dom";

const Plots = () => {
  const navigate = useHistory();
  const queryParameters = new URLSearchParams(window.location.search);
  var type = queryParameters.get("id");
  const [item, setItem] = useState([]);
  const [pno, setPno] = useState([]);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        getItem();
      } else {
        navigate.push("/login?id=" + type + "&page=plots");
      }
    });
  }, []);

  const getItem = async () => {
    const data = await ItemDataService.getItem(type);
    if (data.exists()) {
      setItem(data.data());
      var canvas = document.querySelector("canvas");
    canvas.width = 600;
    canvas.height = 600;
    var c = canvas.getContext("2d");
    
      c.beginPath();
      c.moveTo(0,0)
      c.lineTo(0,0)
      c.lineTo(item.Dx-item.Cx,item.Dy-item.Cy)
      c.lineTo(item.Ax-item.Cx,item.Ay-item.Cy)
      c.lineTo(item.Bx-item.Cx,item.By-item.Cy)
      c.lineTo(0,0)
      c.fillText(item.Length, (0+(item.Dx-item.Cx))/2, ((0+(item.Dy-item.Cy))/2)+10);
      c.fillText(item.Length2, (0+(item.Ax-item.Cx))/2, (((item.By-item.Cy)+(item.Ay-item.Cy))/2)-10);
      c.fillText(item.Width, 10, (0+(item.By-item.Cy))/2);
      c.fillText(item.Width2, (0+(item.Dx-item.Cx)-20), ((item.Dy-item.Cy)+(item.Ay-item.Cy))/2);
      c.stroke();
      c.closePath();
    }
  };
  const updateStatus = () => {
    const today = new Date();
    if (item.Status === "Booked") {
      item.Status = "Allotted";
      item.allotedDate = today;
    } else if (item.Status === "Allotted") {
      item.Status = "Open";
    } else {
      item.Status = "Booked";
      item.bookedDate = today;
    }
    ItemDataService.updateItem(type, item);
    alert("Data submitted successfully!");
    navigate.push("/plots?id=" + type);
  };
  const logout = async () => {
    await auth.signOut();
    navigate.push("/login");
  };
  const moveTo = () => {
    type = pno;
    getItem();
    navigate.push("/plots?id=" + type);
  };
  const inpChange = (event) => {
    setPno(event.target.value);
  };

  return (
    <>
      <div
        className="container"
        style={{
          width: "100%",
          textAlign: "center",
          margin: "3rem",
          backgroundColor: "#ECF6F6",
          padding: "2rem",
        }}
      >
        <button
          onClick={logout}
          style={{ float: "right", padding: "5px", margin: "1rem" }}
        >
          Logout
        </button>
        <input
          type="text"
          value={pno}
          onChange={inpChange}
          placeholder="plot No"
        />
        <input type="submit" onClick={moveTo} value="Search" />
        <br />
        <br />
        <div style={{ width: "100%", margin: "auto" }}>
          <p>
            <strong>Plot No :</strong> {item.No}
          </p>
          <p>
            <strong>Status :</strong> {item.Status}
          </p>
          <p>
            <strong>Length :</strong> {item.Length}
          </p>
          <p>
            <strong>Width :</strong> {item.Width}
          </p>
          <p>
            <strong>Length :</strong> {item.Length2}
          </p>
          <p>
            <strong>Width :</strong> {item.Width2}
          </p>
          <br />
          <button onClick={updateStatus}>Update Status</button>
          <br />
          <canvas style={{ width: "100%" }}></canvas>
        </div>
      </div>
    </>
  );
};

export default Plots;
